import { render, staticRenderFns } from "./PopupFlavorWrite.vue?vue&type=template&id=7244a12b&scoped=true&"
import script from "./PopupFlavorWrite.vue?vue&type=script&lang=js&"
export * from "./PopupFlavorWrite.vue?vue&type=script&lang=js&"
import style0 from "./PopupFlavorWrite.vue?vue&type=style&index=0&id=7244a12b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244a12b",
  null
  
)

export default component.exports